module.exports = __webpack_public_path__ + "media/country_flags/as-f6139db9.png";